// local storage keys for persisting application state
export const CEREBRO_ACCESS_TOKEN = 'CEREBRO_ACCESS_TOKEN'
export const CEREBRO_REFRESH_TOKEN = 'CEREBRO_REFRESH_TOKEN'
export const CEREBRO_ID_TOKEN = 'CEREBRO_ID_TOKEN'
export const CEREBRO_RAIDER_ID_TOKEN = 'CEREBRO_RAIDER_ID_TOKEN'
export const COGNITO_ACCESS_TOKEN = 'COGNITO_ACCESS_TOKEN'
